import { ExportAllListActions } from '../ExportAllButton';
import React from 'react';
import {
  ListGuesser,
  CreateGuesser,
  FieldGuesser,
  InputGuesser,
  ShowGuesser,
} from '@api-platform/admin';
import {
  TextField,
  ReferenceField,
  SelectInput,
  ReferenceInput,
  TranslatableInputs,
  TextInput,
  ChipField,
  SingleFieldList,
  ArrayField,
  DateField,
} from 'react-admin';
import { Grid } from '@mui/material';
import { RichTextInput } from 'ra-input-rich-text';
import { CategoryParentInput } from './Inputs';
import {
  validateCompany,
  validateSeoDescription,
  validateSeoKeywords,
  validateSeoTitle,
} from '../../validators/common';
import {
  validateDescription,
  validateMenuName,
  validateName,
  validatePositionInMenu,
  validateSortOrder,
} from '../../validators/category';
import {
  getSelectedCompanyFilter,
  getSelectedCompanyFilterValue,
} from '../../helper/filter';

export const CategoryList = (props) => {
  const filters = [
    <TextInput label="Parent" source="parent.translations.name" />,
    <TextInput label="Name" source="translations.name" />,
  ];

  const companyFilter = getSelectedCompanyFilter();

  return (
    <ListGuesser
      actions={<ExportAllListActions />}
      {...props}
      filters={filters}
      filter={companyFilter}
    >
      <FieldGuesser source={'name'} sortBy={'translations.name'} />
      <ReferenceField
        label="Company"
        source="company"
        sortBy={'company.name'}
        reference="companies"
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        label="Parent"
        source="parent.@id"
        sortBy={'parent.translations.name'}
        reference="categories"
      >
        <TextField source="name" />
      </ReferenceField>
      <FieldGuesser source={'showInMenu'} />
      <FieldGuesser source={'positionInMenu'} />
      <ReferenceField
        label="CreatedBy"
        source="createdBy"
        sortBy={'createdBy.email'}
        reference="users"
      >
        <TextField source="email" />
      </ReferenceField>
      <DateField source={'updatedAt'} locales={'de'} showTime />
      <DateField source={'createdAt'} locales={'de'} showTime />
    </ListGuesser>
  );
};

export const CategoryShow = (props) => (
  <ShowGuesser {...props}>
    <FieldGuesser source={'drupalId'} />
    <FieldGuesser source={'oldId'} />
    <ReferenceField label="Parent" source="parent.@id" reference="categories">
      <TextField source="name" />
    </ReferenceField>
    <ArrayField source="children">
      <SingleFieldList>
        <ChipField source="name" />
      </SingleFieldList>
    </ArrayField>
    <FieldGuesser source={'createdAt'} />
    <FieldGuesser source={'updatedAt'} />
    <ReferenceField label="CreatedBy" source="createdBy" reference="users">
      <TextField source="email" />
    </ReferenceField>
    <ReferenceField label="UpdatedBy" source="updatedBy" reference="users">
      <TextField source="email" />
    </ReferenceField>
  </ShowGuesser>
);

export const CategoryCreate = (props) => {
  const transform = (data) => {
    console.log({ data });
    data['translations'] = {
      de: {
        name: data.name.de,
        description: data.description.de,
        seoTitle: data.seoTitle.de,
        seoDescription: data.seoDescription.de,
        seoKeywords: data.seoKeywords.de,
        locale: 'de',
      },
      // en: {
      //   name: data.name.en,
      //   description: data.description.en,
      //   seoTitle: data.seoTitle.en,
      //   seoDescription: data.seoDescription.en,
      //   seoKeywords: data.seoKeywords.en,
      //   locale: 'en',
      // },
    };

    return data;
  };

  const companyFilter = getSelectedCompanyFilter();

  return (
    <CreateGuesser {...props} transform={transform}>
      <Grid container spacing={4} sx={{ p: 2 }}>
        <Grid item xs={6}>
          <ReferenceInput
            source="company"
            reference="companies"
            label="Company"
            filterToQuery={(searchText) => ({ name: searchText })}
          >
            <SelectInput
              id="company"
              fullWidth
              source="company"
              optionText="name"
              validate={validateCompany}
              disabled={true}
              defaultValue={companyFilter.company}
            />
          </ReferenceInput>
          <CategoryParentInput
            edit={false}
            company={getSelectedCompanyFilterValue()}
          />
          <InputGuesser
            fullWidth
            id="positionInMenu"
            source={'positionInMenu'}
            validate={validatePositionInMenu}
          />
          <InputGuesser
            fullWidth
            id="sortOrder"
            source={'sortOrder'}
            validate={validateSortOrder}
          />
          <InputGuesser id="showInMenu" fullWidth source={'showInMenu'} />
            <TranslatableInputs locales={['de']} defaultLocale="de">
                <TextInput
                    fullWidth
                    label={'Name in Search field'}
                    source="translationsFormView.nameInSearchField"
                />
                <TextInput
                    fullWidth
                    label={'Name in filter'}
                    source="translationsFormView.nameInFilter"
                />
                <TextInput
                    fullWidth
                    label={'Name in breadcrumb'}
                    source="translationsFormView.nameInBreadcrumb"
                />
            </TranslatableInputs>
        </Grid>
        <Grid item xs={6}>
          <TranslatableInputs locales={['de']} defaultLocale="de">
            <TextInput
              fullWidth
              label={'Name'}
              source="name"
              validate={validateName}
            />
            <TextInput
              fullWidth
              label={'MenuName'}
              source="menuName"
              validate={validateMenuName}
            />
            <RichTextInput
              fullWidth
              label={'Description'}
              source="description"
              validate={validateDescription}
              format={(v) => (v ? v : '')}
              parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
            />
            <TextInput
              fullWidth
              label={'Seo Title'}
              source="seoTitle"
              validate={validateSeoTitle}
            />
            <TextInput
              fullWidth
              label={'Seo Description'}
              source="seoDescription"
              validate={validateSeoDescription}
              multiline
              rows={5}
            />
            <TextInput
              fullWidth
              label={'Seo Keywords'}
              source="seoKeywords"
              validate={validateSeoKeywords}
              multiline
              rows={5}
            />
          </TranslatableInputs>
        </Grid>
      </Grid>
    </CreateGuesser>
  );
};
